var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatient({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fff"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M8.973,323.352h494.055C473.457,432.058,374.073,512,256.001,512 C137.927,512,38.544,432.058,8.973,323.352L8.973,323.352z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FED298"
    },
    cx: 302.659,
    cy: 237.157,
    rx: 9.366,
    ry: 9.199
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.167,
    y: 65.827,
    style: {
      fill: "#15BDB2"
    },
    width: 6.392,
    height: 335.155
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M254.462,131.478l0.08,40.765c0.211,34.381,0.388,64.72,2.535,90.964h-4.184 c-1.948-26.321-1.988-56.619-2.199-90.935l-0.081-40.755L254.462,131.478L254.462,131.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FED298"
    },
    d: "M408.996,154.583c12.08,3.735,18.845,16.554,15.111,28.633c-1.717,5.546-5.337,9.485-9.861,11.909 l-3.269,13.557l-18.513-7.722l2.417-5.317c-10.489-0.926-14.962-1.489-11.289-9.37c-1.529-0.906-2.135-3.802-0.215-5.01 c0,0-0.883-1.399-0.555-2.458c0.327-1.06,1.974-2.804,2.022-2.824c-4.135-0.519-5.157-2.603-4.269-4.075 c1.137-1.883,7.935-4.239,9.113-9.802c0.84-3.965,3.607-6.737,4.764-7.183C398.974,153.285,404.048,153.052,408.996,154.583 L408.996,154.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M394.475,154.916c0,0,15.497-0.008,18.672,5.519c3.175,5.526-4.07,6.621-1.554,9.85 c2.518,3.228,0.28,10.63,0.28,10.63l2.769,0.362c0,0,1.128-4.695,4.66-2.858c3.533,1.836,0.293,9.223-3.788,11.049 c-4.082,1.827-0.905,6.248-0.905,6.248c15.161-9.506,17.332-29.419,10.961-37.572C418.548,149.158,396.835,145.024,394.475,154.916z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15BDB2"
    },
    d: "M291.993,244.976h54.027l22.7-31.157c17.308-32.678,61.098-9.175,40.834,21.751l-24.823,37.886 c-5.887,8.985-11.271,13.017-22.247,12.526h-70.492L291.993,244.976L291.993,244.976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF3F7"
    },
    d: "M80.965,227.806L80.965,227.806c4.02,0,7.306,3.287,7.306,7.306v157.646H73.66V235.112 C73.66,231.092,76.947,227.806,80.965,227.806L80.965,227.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD24D"
    },
    d: "M115.363,242.228h171.821v49.494H90.616v-24.748C90.616,253.364,101.753,242.228,115.363,242.228 L115.363,242.228z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF3F7"
    },
    d: "M88.271,291.525h335.459v13.913H88.271V291.525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF3F7"
    },
    d: "M431.034,227.806h0.001c4.018,0,7.305,3.287,7.305,7.306v157.646h-14.61V235.112 C423.729,231.092,427.016,227.806,431.034,227.806L431.034,227.806z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DADA"
    },
    d: "M88.271,305.437h335.459v-3.666H88.271V305.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF985"
    },
    d: "M298.431,242.463v49.061h-11.244v-49.061C287.187,238.502,298.431,238.502,298.431,242.463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD24D"
    },
    d: "M418.834,233.737l0.001,0.001c5.285,3.574,6.684,10.821,3.108,16.106l-19.003,28.092 c-3.574,5.285-10.82,6.684-16.106,3.108l-0.001-0.002c-5.285-3.574-6.682-10.82-3.108-16.105l19.003-28.092 C406.302,231.563,413.548,230.163,418.834,233.737L418.834,233.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M387.566,203.799l-38.178,48.316l-38.872-20.712c-11.764-6.271-19.928,9.149-10.358,15.533 l46.944,31.308c3.704,2.469,8.574,1.921,11.662-1.052c1.148-0.705,2.194-1.617,3.074-2.733l44.262-56.016 C415.787,206.183,397.252,191.54,387.566,203.799L387.566,203.799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M298.431,282.345h125.298v9.18H298.431V282.345z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15BDB2"
    },
    d: "M159.674,66.784l-1.493,3.055c-1.286,2.633-3.32,4.269-5.523,4.986 c-1.486,0.483-3.052,0.543-4.519,0.209c-1.478-0.339-2.864-1.082-3.99-2.189c-1.616-1.591-2.681-3.921-2.665-6.856 c0.006-1.588,1.299-2.87,2.886-2.864c1.588,0.006,2.869,1.299,2.863,2.886c-0.006,1.242,0.376,2.161,0.952,2.732 c0.345,0.338,0.78,0.572,1.238,0.676c0.462,0.106,0.97,0.085,1.453-0.073c0.802-0.261,1.577-0.924,2.117-2.031l2.252-4.609 c0.454-0.998,1.46-1.695,2.629-1.695c12.318,0,69.197,0,81.514,0c1.168,0,2.175,0.697,2.63,1.695l2.252,4.609 c0.539,1.107,1.314,1.77,2.116,2.031c0.483,0.158,0.991,0.18,1.453,0.073c0.458-0.104,0.892-0.337,1.238-0.676 c0.577-0.571,0.958-1.49,0.952-2.732c-0.006-1.588,1.275-2.881,2.863-2.886c1.588-0.006,2.881,1.277,2.886,2.864 c0.015,2.934-1.049,5.265-2.665,6.856c-1.126,1.107-2.512,1.849-3.99,2.189c-1.467,0.334-3.032,0.274-4.519-0.209 c-2.205-0.718-4.238-2.352-5.523-4.986l-1.493-3.055C226.468,66.784,170.79,66.784,159.674,66.784L159.674,66.784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15BDB2"
    },
    d: "M175.805,378.666h47.122c3.084,0,5.607,2.522,5.607,5.606v5.607h-5.872v-2.436 c0-1.135-0.926-2.062-2.062-2.062h-14.513c-1.135,0-2.062,0.926-2.062,2.062v2.436h-9.321v-2.436c0-1.135-0.926-2.062-2.062-2.062 h-14.514c-1.135,0-2.062,0.926-2.062,2.062v2.436h-5.872v-5.607C170.197,381.189,172.721,378.666,175.805,378.666L175.805,378.666z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DADA"
    },
    d: "M228.595,84.735h36.294v39.564c0,3.95-3.229,7.18-7.18,7.18h-21.934c-3.95,0-7.18-3.23-7.18-7.18 V84.735L228.595,84.735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF3F7"
    },
    d: "M228.595,84.735h36.294V120.7c0,4.429-3.624,8.053-8.053,8.053h-24.609 c-0.809,0-1.591-0.122-2.33-0.345c-0.819-1.166-1.301-2.585-1.301-4.11L228.595,84.735L228.595,84.735z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.594,
    y: 92.859,
    style: {
      fill: "#FEFEFE"
    },
    width: 36.299,
    height: 21.251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.366,
    y: 131.483,
    style: {
      fill: "#EEF3F7"
    },
    width: 4.002,
    height: 4.654
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.582,
    y: 136.134,
    style: {
      fill: "#FEFEFE"
    },
    width: 9.567,
    height: 3.86
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF5B62"
    },
    cx: 246.738,
    cy: 103.478,
    r: 11.794
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M245.351,67.36c0-0.775,0.63-1.406,1.405-1.406c0.776,0,1.406,0.631,1.406,1.406v17.374 c0,0.775-0.63,1.405-1.406,1.405c-0.775,0-1.405-0.63-1.405-1.405V67.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M244.683,95.901h4.117v5.519h5.522v4.121H248.8v5.522h-4.117v-5.522h-5.523v-4.121h5.523V95.901z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.4ce00fb53ca49fb9a7ce7ae7c0cd6cab.svg";
export { ForwardRef as ReactComponent };